<template>
  <div id="default-layout">
    <router-view/>
    <FadeTransition>
      <FullLoading v-if="$store.state.isFullLoading"/>
    </FadeTransition>
  </div>
</template>

<script>
export default {
  components: {
    FadeTransition: () => import('../components/FadeTransition.vue'),
    FullLoading: () => import('../components/FullLoading.vue')
  },
  mounted () {
    this.$store.commit('SET_STATE', { name: 'isFullLoading', val: true })
    this.$nextTick(async () => {
      this.checkAuthentication()
      setTimeout(() => {
        this.$store.commit('SET_STATE', { name: 'isFullLoading', val: false })
      }, 1000)
    })
  },
  methods: {
    async checkAuthentication () {
      const isAuthenticated = await this.$store.dispatch('checkAuthen')
      if (!isAuthenticated) {
        this.$router.replace('/account/login')
      }
    }
  }
}

</script>

<style lang="scss">
</style>
